import { RouteParams } from "../../shared/paramrouting/paramrouting-context";
import { SettingsType } from "adviesbox-shared";

export const createAanleidingUrl = (s: SettingsType, p: RouteParams): string =>
  `${s.klantdossiersFormsOrigin}/Adviesdossiers/${p.adviesdossier}/Aanleiding`;

export const getDossierId = (p: RouteParams): string => p.adviesdossier;
